import React from 'react';
import * as yup from 'yup';
import { useFormik } from 'formik';
import PropTypes from 'prop-types';

import {
  ModalCard,
  showDrawer,
  useCreateModal,
} from 'partial/components/Modal';
import Button from 'partial/components/Button';
import FormInput from 'partial/form/FormInput';
import { useActiveAccount } from 'modules/auth/hooks';
import Form, { ErrorLabel, setError422 } from 'partial/form/Form';

import { useCreateMerchant } from '../hooks';

export const openCreateMerchant = () => {
  showDrawer({
    size: 'xs',
    title: 'Create New Merchant',
    content: (onClose) => <CreateMerchantModal onClose={onClose} />,
  });
};

export const useOpenCreateMerchant = () => {
  const createModal = useCreateModal('CREATE_MERCHANT_MODAL');
  const openModal = React.useCallback(() => {
    createModal({
      content: (onClose) => (
        <ModalCard title="Create New Biller" size="sm" onClose={onClose}>
          <CreateMerchantModal onClose={onClose} />
        </ModalCard>
      ),
    });
  }, [createModal]);
  return [openModal];
};

const initialValues = {
  name: '',
};

const validationSchema = yup.object().shape({
  name: yup.string().required('Required'),
});

function CreateMerchantModal({ onClose }) {
  const [validateOnChange, setValidateOnChange] = React.useState(false);

  const [activeAccount] = useActiveAccount();
  const [isLoading, submit] = useCreateMerchant(onClose);

  const { values, setFieldValue, handleSubmit, errors } = useFormik({
    initialValues,
    validationSchema,
    onSubmit: async (form, { setFieldError }) =>
      submit({ ...form, organization_uuid: activeAccount?.id }, null, (err) => {
        setError422(err, setFieldError);
      }),
    validateOnChange,
  });
  return (
    <div className="flex flex-col space-y-6 px-8 py-8">
      <h2 className="text-xl text-gray-500 font-light">
        Create New Biller by inputting Name
      </h2>
      <Form
        onSubmit={handleSubmit}
        error={errors}
        noValidate
        className=" space-y-6"
      >
        <div>
          <FormInput
            name="name"
            onSetFieldValue={setFieldValue}
            value={values.name}
            label="Biller Name"
            error={errors.name}
            required
          />
          <ErrorLabel name="name" />
        </div>
        <div className="flex justify-center">
          <Button
            size="xl"
            className="mr-2"
            onClick={onClose}
            disabled={isLoading}
          >
            Cancel
          </Button>
          <Button
            primary
            size="xl"
            type="submit"
            disabled={isLoading}
            onClick={() => setValidateOnChange(true)}
          >
            Confirm
          </Button>
        </div>
      </Form>
    </div>
  );
}

CreateMerchantModal.propTypes = {
  onClose: PropTypes.func.isRequired,
};

export default CreateMerchantModal;
